import React, { useEffect } from "react";
import Csv from "../../components/admin/Csv";

const CsvPage = () => {

    useEffect(() => {
            document.body.id = "csvsection-003";
          }, []);
  return (
    <div>
     <Csv />
    </div>
  );
};

export default CsvPage;
